
<div class="paybee-modal-header">
    <div class="modal-title">{{ dialog?.initialState?.modalTitle }}</div>
  </div>
  <div class="modal-body">
    <div class="text-center pb-3 error-message">{{ dialog?.initialState?.errorMessage }}</div>
  </div>
  <div class="modal-footer paybee-modal-footer">
    <div class="row">
      <div class="col-4 offset-4">
        <button type="button" class="btn btn--paybee btn--cancel btn--md text-center w-100" (click)="close(dialog, false)">Ok</button>
      </div>
    </div>
  </div>  

  